interface CtaProps {
  text?: string;
  link?: string;
  backgroundColor?: string;
  textColor?: string;
}

export function CtaBlock({ props }: { props: CtaProps }) {
  const bg = props.backgroundColor || '#6366f1';
  const color = props.textColor || '#ffffff';

  return (
    <div
      className="rounded-xl px-8 py-10 text-center"
      style={{ backgroundColor: bg, color }}
    >
      <p className="text-lg md:text-xl font-semibold mb-4">
        {props.text || 'Call to Action'}
      </p>
      {props.link && (
        <a
          href={props.link}
          className="inline-block rounded-lg px-6 py-2.5 font-medium text-sm transition-opacity hover:opacity-90"
          style={{ backgroundColor: color, color: bg }}
        >
          Learn more
        </a>
      )}
    </div>
  );
}
